import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';
import { PrivilegedGroupsBlock } from '../../_blocks/PrivilegedGroups/PrivilegedGroupsBlock';
import { useSonTranslation } from '../../translation/useSonTranslation';

export type PrivilegedGroupsWidget = ContextWidget<PrivilegedGroupsBlock, WidgetType.privilegedgroups>;

export function PrivilegedGroupsWidget({ elementType, ...props }: PrivilegedGroupsWidget) {
  const { t } = useSonTranslation('PrivilegedGroups');
  const title = t('widgetTitle');

  return <DefaultContextWidget elementType={elementType} icon={Icons.TEAMROOM_PEOPLE} title={title} {...props} />;
}
